module.exports = __webpack_public_path__ + "media/hyper/images/ico-instagram-93f16ea37ca96aef0cf8efcc8912f1bb.png";